/* External */
import { useMemo } from 'react';
import { useIntl } from 'react-intl';

/* Utils */
import {
  getAllGenres,
  getFormattedDuration,
  useFullEpisodeName,
  isEpisode,
  isEvent,
  isMovie,
  isShow,
  isSports,
  joinArrayWithSpace,
} from '../../utils/metaDataUtils';

export function useFirstSubtitleSearchCard(content, isLive = false, invertTitle = false) {
  const fullEpisodeName = useFullEpisodeName(content, invertTitle);

  return useMemo(() => {
    if (isEpisode(content)) {
      return joinArrayWithSpace([
        fullEpisodeName,
      ]);
    }

    if (!isLive || isShow(content)) {
      return joinArrayWithSpace([
        getAllGenres(content),
      ]);
    }

    if (isLive && isSports(content)) {
      return joinArrayWithSpace([
        content?.shortName,
      ]);
    }

    return joinArrayWithSpace([
      getAllGenres(content),
    ]);
  }, [content, fullEpisodeName, isLive]);
}

export function getSecondSubtitleSearchCard(content) {
  return getFormattedDuration(content);
}

export function useThirdSubtitleSearchCard(content) {
  const { formatMessage } = useIntl();
  return useMemo(() => {
    if (isShow(content) || isEpisode(content)) return formatMessage({ id: 'common.serie' });
    if (isSports(content)) return formatMessage({ id: 'common.sport' });
    if (isEvent(content)) return formatMessage({ id: 'common.event' });
    if (isMovie(content)) return formatMessage({ id: 'common.movie' });

    return '';
  }, [content, formatMessage]);
}
